// src/components/Manual.js
import React from "react";
import PropTypes from "prop-types";
import Chapter from "./Chapter";
import { debugLog } from "../utils/index";

const Manual = ({ manual = null }) => {
  if (!manual) {
    debugLog("Manual component received null/undefined manual");
    return null;
  }

  const pageLayoutType = manual?.pageLayoutType || "letter";
  const isQSG = pageLayoutType === "QSG";
  debugLog("manual pageLayoutType", pageLayoutType);

  // Handle empty chapters gracefully
  const chapters = manual.chapters || [];
  debugLog(
    "manual chapter ids",
    chapters.map(item => item.id)
  );

  return (
    <div className={isQSG ? "mx-page-margin-max" : "mx-page-margin page-break"}>
      <div className={isQSG ? "max-w-content-max" : "max-w-contentmaxmargin md:max-w-content"}> {/* if over small screen set to max-w-content */}
        {chapters.length > 0 ? (
          chapters.map((item, idx) => (
            <Chapter key={item.id} {...item} isFirst={idx === 0} />
          ))
        ) : (
          <div className="text-gray-2 italic p-4">{}</div>
        )}
      </div>
    </div>
  );
};

Manual.propTypes = {
  manual: PropTypes.shape({
    title: PropTypes.string,
    chapters: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
      })
    ),
    pageLayoutType: PropTypes.string,
  }),
};

export default Manual;